import React, {useState} from 'react'
import {useFormik} from 'formik'
import AgentLeader from '../../TeamAdmin/SalesChannels/steps/AgentLeader'
import SharedModal from '../../../sharedComponent/SharedModal'
import CustomButton from '../../../sharedComponent/CustomButton'
import * as Yup from 'yup'
import {useMutation} from '@apollo/client'
import {CREATE_AGENT_LEADER} from '../../../../utils/GraphQLAPI'
import {GLOBAL_CONSTANTS} from '../../../../utils/GlobalConstants'
import {alert} from '../../../../utils/helper'
type AgentLeaderProps = {salesAgentId: string | null; getAgentLeaderList: () => void}
const defaultAgentLeaderValues = {
  agentLeaders: [{leaderName: '', leaderCode: '', leaderStatus: true}],
}
const AddAgentLeader = ({salesAgentId, getAgentLeaderList}: AgentLeaderProps) => {
  const [showModal, setShowModal] = useState(false)
  const handleModalClose = () => {
    setShowModal(false)
    formik.setValues(defaultAgentLeaderValues)
    formik.setErrors({})
    formik.setTouched({})
  }
  const [createAgentLeader] = useMutation(CREATE_AGENT_LEADER, {
    onCompleted: () => {
      alert('Agent Leader created  succesfully', 'success')
      handleModalClose()
      getAgentLeaderList()
    },
    fetchPolicy: GLOBAL_CONSTANTS.networkOnlyMutation,
  })
  const formik = useFormik({
    initialValues: defaultAgentLeaderValues,
    validationSchema: Yup.object().shape({
      // Validation for email when we add the products
      agentLeaders: Yup.array().of(
        Yup.object().shape({
          leaderName: Yup.string().required('Agent Leader Name is required'),
          leaderCode: Yup.string().required('Agent Leader Code is required'),
        })
      ),
    }),
    onSubmit: (values) => {
      if (values.agentLeaders.length !== 0) {
        createAgentLeader({
          variables: { leaderInput: values.agentLeaders, salesChannelId: salesAgentId },
        })
      }

      else {
        alert('No Agent Leader found', 'info')
      }
    },
  })
  return (
    <>
      <SharedModal
        handleClose={handleModalClose}
        className='mw-750px'
        handleSubmit={() => {
          formik.submitForm()
        }}
        show={showModal}
        headerName='Agent Leader'
      >
        <div className='p-4 h-450px'>
          <AgentLeader formik={formik} />
        </div>
      </SharedModal>
      <CustomButton
        className='btn btn-primary'
        text='Add Agent Leader'
        pathfromImages='smlplus.svg'
        onClick={() => setShowModal(!showModal)}
      />
    </>
  )
}
export default AddAgentLeader
